interface CourseProgress {
	chapterId: number;
	stepId: number;
}

function storageKey(courseId: string): string {
	return `course-progress:${courseId}`;
}

export function saveCourseProgress(courseId: string, chapterId: number, stepId: number): void {
	try {
		localStorage.setItem(storageKey(courseId), JSON.stringify({ chapterId, stepId }));
	} catch {
		// localStorage may be unavailable
	}
}

export function getCourseProgress(courseId: string): CourseProgress | null {
	try {
		const raw = localStorage.getItem(storageKey(courseId));
		if (!raw) return null;
		return JSON.parse(raw) as CourseProgress;
	} catch {
		return null;
	}
}

export function clearCourseProgress(courseId: string): void {
	try {
		localStorage.removeItem(storageKey(courseId));
	} catch {
		// ignore
	}
}
